// Viewport-aware placement for the spotlight explainer cards (PageTour and
// SandySpotlight). The old logic guessed the card's height and only checked
// the space below the target, so cards near the top or bottom of the screen
// could render half off-viewport. This places by the MEASURED card height:
// below the target if that fits, above if that fits, otherwise clamped into
// the viewport (overlapping the target is the least-bad option then).
export function placeCard(rect, cardW, cardH, gap = 12, edge = 16) {
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const left = Math.min(Math.max(edge, rect.x), vw - cardW - edge);
  const h = cardH || 200; // first-render estimate; re-measured before paint
  const below = rect.y + rect.h + gap;
  const above = rect.y - gap - h;
  let top;
  if (below + h + edge <= vh) top = below;
  else if (above >= edge) top = above;
  else top = Math.max(edge, Math.min(below, vh - h - edge));
  return { left, top };
}
